const equipmentServiceFamilies: string[] = [
	"14",
	"53",
	"54",
	"55",
	"56",
	"63",
	"57",
];

export default equipmentServiceFamilies;
